import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-text-button-link',
  styleUrl: 'cms-text-button-link.scss',
  shadow: true,
})
export class CmsTextButtonLink {
  /**
   * set the target url ref
   */
  @Prop() url: string;
  /**
   * set the container Label or the category Name
   */
  @Prop() label = '';
  /**
   * set the name of the button
   */
  @Prop() buttonText = '';

  render() {
    return (
      <Host>
        {this.url != undefined ? (
          <div class={'text-link-wrapper'}>
            <span class={'text-link-label'}>{this.label}</span>
            <a
              data-eventtype='click'
              data-event='cta_click'
              data-uid='cms-text-button-link'
              href={this.url}
              class={'text-link-anchor'}
            >
              <cms-button
                theme='brand-1'
                size='button-sm'
                type='button'
                label={this.buttonText}
              ></cms-button>
            </a>
          </div>
        ) : null}
      </Host>
    );
  }
}
